module.exports = __webpack_public_path__ + "static/collaborate-fada952f94e5a7e50bd4153589bbe59e.svg";